import React, { useContext } from 'react'
import { Col, Row, Spin, Typography } from 'antd'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'

import IntlMessages from '../../../../util/IntlMessages'
import { SeoTags } from '../../../../components/seo-tags'
import MobileApp from '../../components/mobile-app'
import { ThemeContext } from '../../../../context/themeContext'
import VTLogoPurple from '../../../../assets/images/logo-purple.svg'
import VTLogoWhite from '../../../../assets/images/logo.svg'

const { Paragraph, Title } = Typography

export interface ISigninLayoutProps {
  titleId: string
  descriptionId: string
  isBusy: boolean
  /**
   * Sits under the subtitle rather than inside the step, so an error keeps one place on the
   * page across every step instead of pushing the field it belongs to further down.
   */
  banner?: React.ReactNode
  children: React.ReactNode
}

/**
 * The page frame. Class names are the ones the global stylesheet already defines, which
 * is what keeps this identical to the existing page.
 */
const SigninLayout = ({ titleId, descriptionId, isBusy, banner, children }: ISigninLayoutProps): React.ReactElement => {
  const { theme } = useContext(ThemeContext)

  return (
    <div className="auth-wrap new-signin">
      <SeoTags title="connect.meta.title.signin" description="connect.meta.description" />
      <div className="auth-container">
        <Row>
          <Col span={12} className="auth-sidebar-info">
            <MobileApp />
          </Col>
          <Col span={12} className="auth-sidebar-form">
            {/* The promo column carries the logo until the narrow layout drops that column,
                so the form column shows its own from there down. */}
            {theme === DARK_THEME ? <VTLogoWhite className="signin-mobile-logo" /> : <VTLogoPurple className="signin-mobile-logo" />}
            <Title level={3}>
              <IntlMessages id={titleId} />
            </Title>
            <Paragraph className="auth-sidebar-info-text">
              <IntlMessages id={descriptionId} />
            </Paragraph>
            {banner}
            <Spin spinning={isBusy}>
              <div className="auth-sidebar-content">{children}</div>
            </Spin>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default SigninLayout
